import React from "react";

/**
 * This function generates an Approve Filled Icon as an SVG component.
 *
 * @param {string} cls - additional class for styling
 * @return {JSX.Element} Approve Filled Icon SVG component
 */
export const ApproveFilledIcon = ({ cls = "" }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="Table Nav Buttons Icons">
        <g id="Check_Mark">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3.60156C7.17516 3.60156 3.25 7.52672 3.25 12.3516C3.25 17.1764 7.17516 21.1016 12 21.1016C16.8248 21.1016 20.75 17.1764 20.75 12.3516C20.75 7.52672 16.8248 3.60156 12 3.60156ZM16.8169 9.66844L10.5669 15.9184C10.4448 16.0405 10.2848 16.1016 10.125 16.1016C9.96516 16.1016 9.80516 16.0405 9.68313 15.9184L7.18313 13.4184C6.93891 13.1744 6.93906 12.7789 7.18313 12.5347C7.42719 12.2905 7.82266 12.2905 8.06687 12.5347L10.125 14.5928L15.9331 8.78469C16.1772 8.54047 16.5727 8.54063 16.8169 8.78469C17.0611 9.02875 17.0611 9.42422 16.8169 9.66844Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 12.3516C2 17.8655 6.48609 22.3516 12 22.3516C17.5139 22.3516 22 17.8655 22 12.3516C22 6.83766 17.5139 2.35156 12 2.35156C6.48609 2.35156 2 6.83766 2 12.3516ZM3.25 12.3516C3.25 7.52672 7.17516 3.60156 12 3.60156C16.8248 3.60156 20.75 7.52672 20.75 12.3516C20.75 17.1764 16.8248 21.1016 12 21.1016C7.17516 21.1016 3.25 17.1764 3.25 12.3516Z"
            fill="currentColor"
          />
          <path
            d="M10.5669 15.9184L16.8169 9.66844C17.0611 9.42422 17.0611 9.02875 16.8169 8.78469C16.5727 8.54063 16.1772 8.54047 15.9331 8.78469L10.125 14.5928L8.06687 12.5347C7.82266 12.2905 7.42719 12.2905 7.18313 12.5347C6.93906 12.7789 6.93891 13.1744 7.18313 13.4184L9.68313 15.9184C9.80516 16.0405 9.96516 16.1016 10.125 16.1016C10.2848 16.1016 10.4448 16.0405 10.5669 15.9184Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};
